import {gql, ApolloClient, NormalizedCacheObject} from '@apollo/client';

interface ExperimentConfig {
  experiments: string[];
  shouldLoad: boolean;
  trackingId?: string;
}

const getExperimentsForPath = async (
  path: string,
  client: ApolloClient<NormalizedCacheObject>
): Promise<ExperimentConfig> => {
  const defaultConfig: ExperimentConfig = {
    experiments: [],
    shouldLoad: false,
  };

  if (path.includes('/daily-capacity') || /\/settings\/store\/\d+/.test(path)) {
    try {
      const {data} = await client.query({query: GET_BRAND_ID});
      const brandId = data?.me?.catererAccount?.brands?.[0]?.id;
      return {
        experiments: ['caterer-auto-accept'],
        shouldLoad: true,
        trackingId: brandId,
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error getting brand ID', error);
      return defaultConfig;
    }
  }

  return defaultConfig;
};

export default getExperimentsForPath;

const GET_BRAND_ID = gql`
  query GetBrandId {
    me {
      id
      catererAccount {
        id
        brands {
          id
        }
      }
    }
  }
`;
